import { CountryDto } from '@app/data/dtos/geography/country-dto';
import { GeographicalBoundariesDto } from '@app/data/dtos/geography/geographical-boundaries.dto';
import { PhonePrefixDto } from '@app/data/dtos/geography/phone-prefix.dto';
import { StreetTypeDto } from '@app/data/dtos/geography/street-type.dto';
import { Country } from '@app/entities/models/geography/country.model';
import { GeographicalBoundary } from '@app/entities/models/geography/geography.model';
import { PhonePrefix } from '@app/entities/models/geography/phone-prefix.model';
import { StreetType } from '@app/entities/models/geography/street-type-model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapPhonePrefix: MapFromFn<PhonePrefixDto, PhonePrefix> = (value) =>
  Builder.forModel(PhonePrefix)
    .name(value.name)
    .prefix(value.country_prefix)
    .isoCode(value.country_iso_numeric_code)
    .build();

export const mapPhonePrefixData: MapFromFn<PhonePrefixDto[], PhonePrefix[]> = (value) => value.map(mapPhonePrefix);

export const mapGeographicalBoundaries: MapFromFn<GeographicalBoundariesDto, GeographicalBoundary> = (value) =>
  Builder.forModel(GeographicalBoundary)
    .name(value.name)
    .alternativeCode(value.alternative_code)
    .parentTypeId(value.parent_type_id)
    .build();

export const mapGeographicalBoundariesData: MapFromFn<GeographicalBoundariesDto[], GeographicalBoundary[]> = (value) =>
  value.map(mapGeographicalBoundaries);

export const mapStreetType: MapFromFn<StreetTypeDto, StreetType> = (value) =>
  Builder.forModel(StreetType).name(value.name).id(value.id).build();

export const mapStreetTypeData: MapFromFn<StreetTypeDto[], StreetType[]> = (value) => value.map(mapStreetType);

export const mapCountry: MapFromFn<CountryDto, Country> = (value) =>
  Builder.forModel(Country)
    .name(value.name)
    .hierarchyCode(value.hierarchy_code)
    .countryIsoNumericCode(value.country_iso_numeric_code)
    .build();

export const mapCountryData: MapFromFn<CountryDto[], Country[]> = (value) => value.map(mapCountry);
